import { render, staticRenderFns } from "./ClaimDetailView.vue?vue&type=template&id=0fcdde8a&scoped=true"
import script from "./ClaimDetailView.vue?vue&type=script&lang=ts"
export * from "./ClaimDetailView.vue?vue&type=script&lang=ts"
import style0 from "./ClaimDetailView.vue?vue&type=style&index=0&id=0fcdde8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcdde8a",
  null
  
)

export default component.exports